import { GetYearInReviewResponse, YearInReviewMetricEntry } from 'pbts/c1/api/metrics/v1/metrics'
import { MetricsServiceClient } from 'pbts/c1/api/metrics/v1/metrics.client'
import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'

export type YearInReviewMetrics = {
    metrics: YearInReviewMetricEntry[]
}

const transformResponse = (resp: GetYearInReviewResponse): YearInReviewMetrics => ({
    metrics: resp.metrics,
})

export const yearInReviewApi = createUnaryApi(
    MetricsServiceClient,
    'getYearInReview',
    transformResponse,
)
